import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "chevron-vertical-12", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 12 12", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("path", { fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, d: "M9 5 6 8 3 5" }));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
